import Block from '../../block'

export default class ShoppingcartShipping extends Block {
	static title = 'shoppingcart-shipping'

	constructor($el) {
		super($el)

		this.formAutosubmit = this.$el.findElement('form--autosubmit')
		this.select = this.formAutosubmit.find('sl-select')

		this.select.on('sl-change', (e) => {
			const selected = $(e.target).find('sl-option[aria-selected="true"]')
			this.select
				.find('span.whitespace-nowrap')
				.text('+ €' + selected.data('price'))
			this.formAutosubmit.submit()
		})
	}
}
